import styled from 'styled-components'

export const _BrokrageAndMLSCont = styled.div`
  width: 100%;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  > div {
    font-family: var(--secondary-font);
    margin: 20px 0 0;
    display: inline-block;
    white-space: pre-wrap;
  }
`
